import React from 'react';

// helpers
import {useTranslation} from 'react-i18next';
import {formatCurrency} from '../../helpers';

// components
import {CardBorder} from '../CardBorder';
import {Divider} from '@mui/joy';

// styles
import {
  CardPaymentWrapper,
  CardPaymentTop,
  CardPaymentTopLeft,
  CardPaymentBottom,
  CardPaymentBottomLeft,
  CardPaymentBottomLeftItem,
  DeferButton,
} from './CardPayment-styles';
import {
  Subtitle,
  TextColors,
  TextSmall,
  TextExtraSmall,
  TextDefault,
} from '../../styles';

// types
import {LoanPayment} from '../../services/ApiService/types';

type Props = {
  payment: LoanPayment;
  onDeferPaymentClick: (e: React.MouseEvent, payment: LoanPayment) => void;
};

const CardPaymentLoan = ({payment, onDeferPaymentClick}: Props) => {
  const {t} = useTranslation();

  return (
    <CardBorder variant="grey">
      <CardPaymentWrapper>
        <CardPaymentTop>
          <CardPaymentTopLeft>
            <Subtitle
              bold="bold"
              color={TextColors.brand}>{`#${payment.paymentNumber}`}</Subtitle>
            <TextSmall bold="bold">{payment.status}</TextSmall>
          </CardPaymentTopLeft>
          <TextExtraSmall bold="bold">{payment.paymentDate}</TextExtraSmall>
        </CardPaymentTop>
        <Divider />
        <CardPaymentBottom>
          <CardPaymentBottomLeft>
            <CardPaymentBottomLeftItem>
              <TextSmall color={TextColors.secondary}>
                {t('loan_payment_total_payment_amount')}
              </TextSmall>
              <TextDefault bold="bold">
                {formatCurrency(payment.paymentAmount)}
              </TextDefault>
            </CardPaymentBottomLeftItem>
            <CardPaymentBottomLeftItem>
              <TextSmall color={TextColors.secondary}>
                {t('payment_balance')}
              </TextSmall>
              <TextDefault bold="bold">
                {formatCurrency(payment.balance)}
              </TextDefault>
            </CardPaymentBottomLeftItem>
          </CardPaymentBottomLeft>
          {payment.canBeDeferred && (
            <DeferButton
              variant="outlined"
              onClick={(e) => onDeferPaymentClick(e, payment)}>
              {t('payment_defer')}
            </DeferButton>
          )}
        </CardPaymentBottom>
      </CardPaymentWrapper>
    </CardBorder>
  );
};

export default CardPaymentLoan;
